<section [id]="fields.scroll_anchor_id" class="rights-section">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-10">
        <div class="section-title">
          <h2>{{fields.headline}}</h2>
          <p class="subtitle">{{fields.subheadline}}</p>
          <!-- Agregamos el icono grande debajo del subtítulo -->
          <div class="icon-wrapper">
            <img [src]="fields.image" alt="Icono Ley 27.350" class="large-icon hero-image">
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <ng-container *ngFor="let right of fields.rights">
            <div class="col-lg-12 col-md-12">
              <div class="single-right">
                <div class="right-content m-1">
                  <h4>{{right.headline}}</h4>
                  <p>{{right.description}}</p>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</section>
